



















































import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { fetchAltasCrm } from '@/pantallas/Conecta/AltasCrm/fetchAltasCrm';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';

@Component({
  components: {},
})
export default class ConfigurarDetalleForm extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  readonly funcionalidad: Funcionalidades = Funcionalidades.AltaCrm;

  @Prop({ default: '' }) AltaCrm_Seleccionada: any;
  @Prop() NombreAlta: string;

  loadingPDF: boolean = true;
  ordenesServicio: Array<any> = [];
  selectedOrdenServicio: string = '';
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  isFormValid: boolean = false;
  url: string = '';

  //ejecuta la función onPatenteChanged cada vez que la propiedad patente del componente cambie su valor.
  @Watch('patente')
  onPatenteChanged(newValue: string) {
    console.log('En ConfigurarDetalleForm - Nuevo valor de patente:', newValue);
    // Restablece la selección de la orden de servicio y carga las nuevas órdenes.
    this.selectedOrdenServicio = '';
    this.url = ''; //  limpia la URL del PDF para evitar mostrar un PDF no deseado.
    this.cargarOrdenesServicio();
  }

  mounted() {
    console.log('mensaje desde configurardetalleform');
    this.cargarOrdenesServicio();
  }

  // Observa cambios en la propiedad 'selectedOrdenServicio'. Cada vez que su valor cambie, se ejecutará la función 'actualizarPDF'.
  @Watch('selectedOrdenServicio')
  actualizarPDF(newValue: string) {
    this.url = '';
    if (newValue) {
      const ordenSeleccionada = this.ordenesServicio.find(
        orden => orden.altaserorden_numero === newValue
      );
      const nuevaUrl = ordenSeleccionada ? ordenSeleccionada.informepdf : '';
      if (this.url !== nuevaUrl) {
        this.url = nuevaUrl;
      }
    } else {
      this.url = ''; // Limpia la URL del PDF si no hay una orden seleccionada
    }
  }

  cargarOrdenesServicio() {
    let self = this;
    let body: any = {};
    body.numeroAlta = self.NombreAlta;
    this.loadingService.showLoading(undefined, 'getOrdenesServicios');
    return fetchAltasCrm({ ...body }, 'conecta_altas_crm/getOrdenesServicios')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordenesServicio = data.data.LISTA;
          return data.data.LISTA;
        }
      })
      .catch((error: any) => null)
      .finally(() => this.loadingService.hideLoading('getOrdenesServicios'));
  }
}
